<template>
  <v-container
    id="shop-table"
    tag="section"
  >
    <base-material-card
      color="warning"
      icon="mdi-file-search"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ title }}
        </div>
      </template>
      <v-row>
        <v-col
          cols="12"
          md="12"
        >
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            :label="$t('search')"
            hide-details
            single-line
            style="max-width: 250px;"
          />
        </v-col>
      </v-row>

      <v-divider class="mt-3" />

      <v-data-table
        :headers="localizationHeaders"
        :items="items"
        :search.sync="search"
        :sort-by="['name']"
        :sort-desc="[false]"
        :loading="loading"
      >
        <!-- <template v-slot:top>
          <v-toolbar
            flat
          >
            <v-spacer />
            <v-btn
              elevation="1"
              color="primary"
              dark
              fab
              min-width="0"
              small
              @click="addOrder"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-toolbar>
        </template> -->
        <!-- <template v-slot:[`item.status`]="{ item }">
          {{ item.status ? "Activo": "Inactivo" }}
        </template> -->
        <template v-slot:[`item.registerDate`]="{ item }">
          {{ item.registerDate | formatDate }}
        </template>
        <template v-slot:[`item.totalWithShipping`]="{ item }">
          {{ "$" + item.totalWithShipping }}
        </template>
        <!-- <template v-slot:[`item.priceSell`]="{ item }">
          {{ "$" + item.priceSell }}
        </template> -->
        <template v-slot:[`item.cardName`]="{ item }">
          <router-link :to="{ name: 'order', params: { id: item.id }}">
            {{ item.orderNumber }}
          </router-link>
        </template>
        <template v-slot:[`item.imageUrl`]="{ item }">
          <a
            v-if="get_url_extension(item.imageUrl) === 'pdf'"
            class=""
            :href="item.imageUrl"
            target="_blank"
          ><span asp-loc>Ver PDF</span></a>
          <v-btn
            v-else
            color="success"
            class="px-1 ml-1 d-flex d-sm-none"
            fab
            x-small
          >
            <v-icon

              @click="showDialog(item.imageUrl)"
            >
              mdi-file-image
            </v-icon>
          </v-btn>
          <v-img
            class="d-none d-sm-flex"
            :lazy-src="item.imageUrl"
            max-height="100%"
            max-width="50px"
            :src="item.imageUrl"
            @click="showDialog(item.imageUrl)"
          />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            color="success"
            class="px-1 ml-1"
            fab
            tooltip="Validar"
            style="margin-right:30px !important"
            x-small
          >
            <v-icon @click="acceptTransfer(item.id)">
              mdi-check
            </v-icon>
          </v-btn>
          <v-btn
            color="warning"
            class="px-1 ml-1"
            fab
            x-small
          >
            <v-icon @click="rejectTransfer(item.id)">
              mdi-cancel
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
      <template>
        <div class="text-center">
          <v-dialog
            v-model="dialog"
            width="700"
          >
            <v-card>
              <v-img
                :lazy-src="dialogImage"
                :src="dialogImage"
                @click="dialog = false"
              />
            </v-card>
          </v-dialog>
        </div>
      </template>
    </base-material-card>

    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import { repositoryFactory } from '@/api/repositoryFactory'
  import filters from '@/common/filters'
  const ordersRespository = repositoryFactory.get('orders')

  export default {
    name: 'OrderValidateList',
    mixins: [filters],
    data: () => ({
      items: [],
      search: undefined,
      loading: false,
      showErrorMessage: false,
      errorMessage: '',
      dialog: false,
      dialogImage: '',
    }),
    computed: {
      title: {
        get () {
          return this.$t('orderValidate')
        },
      },
      localizationHeaders () {
        return [
          {
            text: this.$t('tables.orders.number'),
            value: 'orderNumber',
          },
          {
            text: this.$t('tables.orders.customer'),
            value: 'customerName',
          },
          {
            text: this.$t('tables.orders.date'),
            value: 'registerDate',
          },
          {
            text: this.$t('tables.orders.transferNumber'),
            value: 'transferNumber',
          },
          {
            text: this.$t('tables.orders.bankAccount'),
            value: 'transferBankDetail',
          },
          {
            text: this.$t('tables.orders.imageUrl'),
            value: 'imageUrl',
          },
          {
            text: this.$t('tables.orders.total'),
            value: 'totalWithShipping',
          },
          {
            sortable: false,
            text: this.$t('actions'),
            value: 'actions',
          },
        ]
      },
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        var self = this
        self.loading = true
        await ordersRespository.getForValidation().then(response => {
          if (response.data.isValid) {
            self.items = response.data.data
            console.log(response.data.data)
          } else {
            self.showErrorMessage = true
            self.errorMessage = response.data.errorMessages[0]
          }
          console.log(response)
          self.loading = false
        }).catch(err => {
          self.showErrorMessage = true
          if (err.response.status === 400) {
            self.errorMessage = err.response.data.errorMessages[0]
          } else {
            self.errorMessage = err
          }
          self.loading = false
        })
      },
      acceptTransfer (id) {
        console.log(id)
        var data = { id: id, isActive: true, reason: '', status: 'active', isTransferAccepted: true, isPaymentMade: true, closed: false }
        ordersRespository
          .updateOrder({ data: data }, id)
          .then(response => {
            if (response.data.isValid) {
              this.fetch()
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          })
          .catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = true
          })
      },
      rejectTransfer (id) {
        var data = { id: id, isActive: false, reason: 'Transferencia Inválida', status: 'cancel', isTransferAccepted: false, isPaymentMade: false, closed: true }
        ordersRespository
          .updateOrder({ data: data }, id)
          .then(response => {
            if (response.data.isValid) {
              this.fetch()
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          })
          .catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = true
          })
      },
      get_url_extension (url) {
        return url ? url.split(/[#?]/)[0].split('.').pop().trim() : ''
      },
      showDialog (url) {
        this.dialog = true
        this.dialogImage = url
      },
      editOrder (id) {
        this.$router.push({ name: 'order', params: { id: id } })
      },
    },
  }
</script>
